import React from 'react';
import MusicListItemView from './MusicListItemView';
import { MusicEntity } from '../../types/MusicEntityTypes';

export default function MusicListView({
  musics,
  onEdit,
  onEditPermissionToUse,
} : {
  musics: MusicEntity[],
  onEdit: (music: MusicEntity) => void,
  onEditPermissionToUse: (music: MusicEntity) => void,

}) {
  const musicListItemViews = musics.map((music) => (
    <MusicListItemView
      key={music.id}
      music={music}
      onEdit={() => { onEdit(music); }}
      onEditPermissionToUse={() => { onEditPermissionToUse(music); }}
    />
  ));
  return (
    <form className="music_list">
      <div className="song_list">
        {musicListItemViews}
      </div>
    </form>
  );
}
